import { useEffect } from "react";

import {
  installConsoleErrorReporter,
  recordClientError,
  recordClientErrorFromReason,
} from "src/utils/clientErrorReporting";

function GlobalErrorHandlers() {
  useEffect(() => {
    const restoreConsole = installConsoleErrorReporter();

    const onError = (
      message: Event | string,
      source?: string,
      lineno?: number,
      colno?: number,
      error?: Error
    ) => {
      const msg =
        typeof message === "string"
          ? message
          : message instanceof ErrorEvent
          ? message.message
          : "Unknown error";

      recordClientError({
        source: "window.onerror",
        message: msg,
        name: error?.name,
        stack: error?.stack,
        filename: source,
        lineno,
        colno,
      });
    };

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      recordClientErrorFromReason("unhandledrejection", event.reason);
    };

    window.onerror = onError;
    window.addEventListener("unhandledrejection", onUnhandledRejection);

    return () => {
      window.onerror = null;
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
      restoreConsole();
    };
  }, []);

  return null;
}

export default GlobalErrorHandlers;
